<!-- <sh-grid>
  <div columns="6" style="border-right: 1px solid gray; margin: 0; padding: 8px; margin-top: -0.8%">
    <div class="center-align" >
      <sh-text style="font:var(--title-1);">News Feed</sh-text>
      <div columns="12" style="overflow-y: auto; max-height: 550px">
        <sh-grid>
          <div columns="6" >

          </div>
        </sh-grid>
      </div>
    </div>
  </div>
  <div columns="6">
    <div class="center-align">
      <sh-text style="font:var(--title-1);">Messenger</sh-text>
    </div>
  </div>
</sh-grid> -->
<!-- <div style="height: 100%">
    <div class="center">
        <sh-icon slot="functions" icon="addin-info" style="margin: auto; font-size: 89px"></sh-icon><br>
        <h1>Under construction</h1>
    </div>
</div> -->

<div class="home-div">

  <gallery id="img-gallery" [items]="images" [thumb]="options.thumb" [autoPlay]="options.autoplay"
  [imageSize]="options.imageSize" [loadingStrategy]="options.loadingStrategy" 
  [counter]="options.counter" [disableThumb]="options.disableThumb"></gallery> 

  <sh-grid class="home-grid" spacing="8px" id="newestAssetGrid">

    <!-- <sh-card *ngFor="let assetCategory of homeAssetsArr" columns="12" style="padding-bottom:10px;"
      id="{{assetCategory.name}}_category">
      <sh-text id="{{assetCategory.name}}_categoryHeaderText" size='super-header'
        style="text-align: center;cursor: pointer" slot="header" (click)="navigateUrl(assetCategory.name)">Newest in
        {{assetCategory.name}}</sh-text>

      <sh-grid columns="10" spacing="l" style="overflow-x: hidden;">
        <div columns="1"></div>
        <div *ngFor="let asset of assetCategory.assetCards" columns="2" class="assetOutline" col-m="4" col-s="12">
          <app-asset-card id="{{asset.assetName}}_assetCard" [asset]="asset"></app-asset-card>
        </div>
        <div columns="1"></div>
      </sh-grid>
    </sh-card> -->

    <sh-card *ngFor="let assetCategory of homeAssetsArr" columns="12" class="newCard">
      <sh-text id="{{assetCategory.name}}_categoryHeaderText" size='super-header' class="home-asset-text" (click)="navigateUrl(assetCategory.name)">Newest in
        {{assetCategory.name}}</sh-text>
      <sh-grid class="overflow-hidden" columns="10" spacing="l">
        <div columns="1"></div>
        <div *ngFor="let asset of assetCategory.assetCards" columns="2" class="assetOutline" col-m="4" col-s="12">
          <app-asset-card id="{{asset.assetName}}_assetCard" [asset]="asset"></app-asset-card>
        </div>
        <div columns="1"></div>
      </sh-grid>
    </sh-card>

    <br>

  </sh-grid>
</div>